import React, { useEffect } from 'react'
import HeaderSec from '../../HeaderSec/HeaderSec'
import FooterComp from '../FooterComp'
import FooterSecComp from '../FooterSecComp'
import disclaimer from '../../../Assets/img/Disclaimer.png'


const Disclaimer = () => {
    useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

    const section1 = [
        'GuideStarIndia.org, on behalf of Civil Society Information Services India, shall endeavour to display only such information on pages whose content is solely generated by GuideStarIndia, as it has verified from the NGOs, or otherwise as being true to the best of GuideStarIndia.org’s knowledge and belief. However, GuideStarIndia.org does not accept any liability due to inaccuracy of information or data provided on this portal by NPOs, NGOs and other organisations. Any liabilities arising out of any act or omission by a user or visitor to this Website, by relying on or using the information provided on this Website, shall be solely to the account of such user or visitor.',
        'GuideStarIndia.org shall exert reasonable influence at its command, including withdrawal of incorrect NPO/NGO and other information from the portal, if, in its opinion, the situation merits such action. However, GuideStarIndia.org is indemnified by users and visitors to this Website, from any liabilities arising out of any kind of use of information displayed on this Website.',
        'GuideStarIndia.org disclaims any liability, legal or otherwise, that may arise due to the act, omission or otherwise of any user or visitor to this Website or caused by the same. Users and Visitors to the portal acknowledge that GuideStarIndia.org is purely a "facilitator" for information between the NPOs/NGOs and users/visitors, and as such, stands indemnified from any liabilities that may arise due to the same. Users and Visitors also acknowledge that using or visiting this Website is an implicit acceptance of this disclaimer on their part.'

    ]

  return (
    <div className='max-w-screen overflow-hidden'>
        <HeaderSec/>
        <div className='max-w-[1200px] m-auto min-h-[500px]'>
            <FooterSecComp
                image={disclaimer}
                topic={'Disclaimer'}
                section={section1}
            />
        </div>
        <FooterComp/>
    </div>
  )
}

export default Disclaimer